import { client, STORE_SLUG, TOKEN_KEY } from "./index";

// The shopper's bell: alerts about their own orders (backend routes/storefrontAlerts.js)
export const getAlerts = () => client.get("/storefront/alerts").then((res) => res.data);
export const markAlertsRead = (ids) => client.post("/storefront/alerts/read", ids ? { ids } : { all: true }).then((res) => res.data);
export const getPushKey = () => client.get("/storefront/alerts/push-key").then((res) => res.data.publicKey);
export const savePushSubscription = (subscription) => client.post("/storefront/alerts/push-subscriptions", subscription);

// The live stream of new alerts (Server-Sent Events read with fetch, so the shopper's token goes in a header).
// onEvent(name, data) for each event; resolves when the stream ends, rejects when it fails. `signal` stops it.
export async function readAlertStream(onEvent, signal) {
  const headers = { "x-auth-token": localStorage.getItem(TOKEN_KEY) || "", Accept: "text/event-stream" };
  if (STORE_SLUG) headers["x-store-slug"] = STORE_SLUG;
  const res = await fetch(`${client.defaults.baseURL || "/api"}/storefront/alerts/stream`, { headers, cache: "no-store", signal });
  if (!res.ok || !res.body) {
    const error = new Error(`Alert stream answered ${res.status}`);
    error.status = res.status;
    throw error;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    // eslint-disable-next-line no-await-in-loop -- one chunk at a time, as the server sends them
    const { value, done } = await reader.read();
    if (done) return;
    buffer += decoder.decode(value, { stream: true });
    let end = buffer.indexOf("\n\n");
    while (end !== -1) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      let name = "message";
      let data = "";
      block.split("\n").forEach((line) => {
        if (line.startsWith("event: ")) name = line.slice(7);
        else if (line.startsWith("data: ")) data += line.slice(6);
      });
      if (data) {
        try { onEvent(name, JSON.parse(data)); } catch { /* a broken event is skipped */ }
      }
      end = buffer.indexOf("\n\n");
    }
  }
}
